import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import request from "../../lib/requester";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import { Link } from "react-router-dom";

class UserUpdate extends Component {
  state = {
    loading: false,
    success: "",
    error: [],
    username: "",
    realname: "",
    activeFlag: "",
    lovBranch: [],
    listBranch: [],
    lovRole: [],
    lovOrigin: [],
    roleId: "",
    originId: "",
    branchId: "",
    updateBy: "",
    phone: "",
    selectAllBranches: false,
  };

  componentDidMount() {
    this.getDetailUser();
  }

  getDetailUser = () => {
    const { id } = this.props.match.params;
    const url = "/arman/v1/user/userupdate";
    const param = { user_id: id };

    this.setState({ loading: true });

    request.postArman(url, param, {
      success: (response) => {
        const { header, branchlov, role, origin, branch } = response.data.data;
        const user = JSON.parse(localStorage.getItem("is_user"));

        
        this.setState({
          loading: false,
          username: header.username,
          realname: header.realname,
          roleId: header.role_id,
          originId: header.origin,
          activeFlag: header.active_flag,
          lovBranch: branchlov,
          listBranch: branch,
          lovRole: role,
          lovOrigin: origin,
          updateBy: user.user_id,
          phone: header.phone,
          selectAllBranches: branchlov.length === branch.length,
        });
      },
      error: (err) => {
        console.error(err);
        this.setState({ loading: false });
      },
    });
  };

  handleSave = () => {
    if (this.state.listBranch.length === 0) {
      alert("Please choose a branch!");
      return;
    }

    const url = "/arman/v1/user/update";
    const param = {
      username: this.state.username,
      realname: this.state.realname,
      phone: this.state.phone,
      role_id: this.state.roleId,
      active_flag: this.state.activeFlag,
      updated_by: this.state.updateBy,
      origin: this.state.originId,
      branch: this.state.listBranch,
    };

    this.setState({ loading: true });

    request.postArman(url, param, {
      success: (response) => {
        this.setState({ loading: false, success: response.data.message });
        window.scrollTo(0, 0);
        setTimeout(() => {
          this.props.history.push("/admin/setup/user/userlist");
        }, 2000);
      },
      error: () => {
        window.scrollTo(0, 0);
        this.setState({
          loading: false,
          error: ["Failed to submit, please try again"],
        });
      },
    });
  };

  handleCancel = () => {
    this.props.history.push("/admin/setup/user/userlist");
  };

  handleChangeOrigin = (event) => {
    const { value } = event.target;
    const { lovBranch } = this.state;

    this.setState({ originId: value, listBranch: [] });

    lovBranch.forEach((item) => {
      document.getElementById(`defaultCheck_${item.org_id}`).checked = false;
    });
  };

  handleChangeRole = (event) => {
    this.setState({ roleId: event.target.value });
  };

  handleChangeActive = (event) => {
    this.setState({ activeFlag: event.target.value });
  };

  setChecked = (item) => {
    return (
      this.state.listBranch &&
      this.state.listBranch.some((branch) => branch.org_id === item.org_id)
    );
  };

  handleClickBranch = (e) => {
    const { checked, value } = e.target;
    const orgId = parseInt(value);

    this.setState((prevState) => {
      let updatedListBranch = Array.isArray(prevState.listBranch)
        ? [...prevState.listBranch]
        : [];
      if (checked) {
        updatedListBranch.push({ org_id: orgId });
      } else {
        updatedListBranch = updatedListBranch.filter(
          (item) => item.org_id !== orgId
        );
      }
      return { listBranch: updatedListBranch };
    });
  };

  handleSelectAllBranches = (e) => {
    const { checked } = e.target;
    const { lovBranch } = this.state;

    const updatedListBranch = checked
      ? lovBranch.map((item) => ({ org_id: parseInt(item.org_id) }))
      : [];

    this.setState({
      selectAllBranches: checked,
      listBranch: updatedListBranch,
    });

    lovBranch.forEach((item) => {
      document.getElementById(`defaultCheck_${item.org_id}`).checked = checked;
    });
  };

  renderBranch = () => {
    return this.state.lovBranch.map((item, index) => (
      <div className="col-md-4" key={index}>
        <div className="form-check">
          <input
            className="form-check-input"
            checked={this.setChecked(item)}
            type="checkbox"
            value={item.org_id}
            onChange={this.handleClickBranch}
            id={`defaultCheck_${item.org_id}`}
          />
          <label
            className="form-check-label"
            htmlFor={`defaultCheck_${item.org_id}`}
          >
            {item.org_name}
          </label>
        </div>
      </div>
    ));
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const {
      success,
      error,
      username,
      realname,
      originId,
      roleId,
      phone,
      activeFlag,
      lovOrigin,
      lovRole,
      selectAllBranches,
      loading,
    } = this.state;

    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className="card-header">User Information</div>
                  <div className="card-body">
                    {success && (
                      <div className="alert alert-success" role="alert">
                        {success}
                      </div>
                    )}
                    {error.length > 0 && (
                      <div className="alert alert-danger" role="alert">
                        <ul>
                          {error.map((item, index) => (
                            <li key={index}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    <form className="form-horizontal">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="username"
                              className="col-sm-3 col-form-label"
                            >
                              Username
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                className="form-control"
                                id="username"
                                name="username"
                                value={username}
                                onChange={this.handleInputChange}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="realname"
                              className="col-sm-3 col-form-label"
                            >
                              Realname
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                className="form-control"
                                id="realname"
                                name="realname"
                                value={realname}
                                onChange={this.handleInputChange}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="origin"
                              className="col-sm-3 col-form-label"
                            >
                              Origin
                            </label>
                            <div className="col-sm-9">
                              <select
                                className="form-control"
                                name="originId"
                                value={originId}
                                onChange={this.handleChangeOrigin}
                              >
                                <option>- Select Origin -</option>
                                {lovOrigin.map((item, index) => (
                                  <option value={item.origin} key={index}>
                                    {item.origin}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="role"
                              className="col-sm-3 col-form-label"
                            >
                              Role
                            </label>
                            <div className="col-sm-9">
                              <select
                                className="form-control"
                                name="roleId"
                                value={roleId}
                                onChange={this.handleChangeRole}
                              >
                                <option>- Select Role -</option>
                                {lovRole.map((item, index) => (
                                  <option value={item.role_id} key={index}>
                                    {item.role_name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="phone"
                              className="col-sm-3 col-form-label"
                            >
                              Phone
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                className="form-control"
                                id="phone"
                                name="phone"
                                value={phone}
                                onChange={this.handleInputChange}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="active"
                              className="col-sm-3 col-form-label"
                            >
                              Active
                            </label>
                            <div className="col-sm-9">
                              <select
                                className="form-control"
                                name="activeFlag"
                                value={activeFlag}
                                onChange={this.handleChangeActive}
                              >
                                <option value="Y">Y</option>
                                <option value="N">N</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-8">
                          <p>
                            <b style={{ fontSize: "1.4em" }}>Branch</b> [
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                this.handleSelectAllBranches({
                                  target: {
                                    checked: !selectAllBranches,
                                  },
                                });
                              }}
                            >
                              {selectAllBranches
                                ? "Unselect All"
                                : "Select All"}
                            </a>
                            ]
                          </p>
                          <div className="row">{this.renderBranch()}</div>
                        </div>
                      </div>
                      <hr />
                      <div className="form-group row">
                        <div className="col-md-6">
                          <div className="col-sm-9">
                            <button
                              type="button"
                              className="btn btn-success"
                              onClick={this.handleSave}
                            >
                              Update
                            </button>
                            &nbsp;
                            <button
                              type="button"
                              className="btn btn-warning"
                              onClick={this.handleCancel}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={loading} />
        </section>
      </div>
    );
  }
}

export default UserUpdate;
